import { render } from "./customSliderPagination.vue?vue&type=template&id=f497cb34"
import script from "./customSliderPagination.vue?vue&type=script&lang=js"
export * from "./customSliderPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__